import React, { Component } from 'react';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import dataProvider, { UNPUBLISH, PUBLISH } from 'config/providers/dataProvider';
import PropTypes from 'prop-types';

import { can, CHANGE_PROYECTO, PUBLISH_PROYECTO } from '~utils/permissions';

import { PUBLISHED } from './constants';

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right'
};

class ShowCustomActions extends Component {

  handlePublish = () => {
    const { data, resource } = this.props;
    dataProvider(PUBLISH, resource, data).then(this.redirect);
  };

  handleUnpublish = () => {
    const { data, resource } = this.props;
    dataProvider(UNPUBLISH, resource, data).then(this.redirect);
  };

  rediretToEdit = () => {
    window.location = `/#/projects/${this.props.id}/edit`;
  }

  redirect = () => {
    location.reload();
  };

  render() {
    const { permissions, data, translate: t } = this.props;
    return (
      <CardActions style={cardActionStyle}>
        {data && can(permissions, CHANGE_PROYECTO) && data.editable && (
            <Button color="primary" href={`#/project-tracking/${encodeURIComponent(data.id)}`}>
              {t('buttons.tracking')}
            </Button>
        )}
        {/* The Edit button lives in the parent ShowActions, which gates it on the
            same `editable` flag -- rendering it here too would duplicate it. */}
        {/* `editable` already encodes the country overlap, so this is country-scoped. */}
        {data && can(permissions, PUBLISH_PROYECTO) && data.editable && data.publishable && (
            <>
              {data.publicationStatus === PUBLISHED ? (
                  <Button color="primary" onClick={this.handleUnpublish}>
                    {t('buttons.unpublish')}
                  </Button>
              ) : (
                  <Button color="primary" onClick={this.handlePublish}>
                    {t('buttons.publish')}
                  </Button>
              )}
              {/*<Button color="primary" onClick={this.rediretToEdit}>*/}
              {/*  {t('buttons.edit')}*/}
              {/*</Button>*/}
            </>
        )}
      </CardActions>
    );
  }
}

ShowCustomActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({
    editable: PropTypes.bool,
    publicationStatus: PropTypes.string,
    publishable: PropTypes.bool
  }),
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  permissions: PropTypes.shape({
    codes: PropTypes.arrayOf(PropTypes.string),
    countries: PropTypes.arrayOf(PropTypes.number),
    role: PropTypes.string
  }),
  resource: PropTypes.string,
  translate: PropTypes.func
};

export default ShowCustomActions;
